import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-20 md:py-28 bg-background-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 border border-accent-500/30 rounded-full mb-3">
            专题索引
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white">
            吃瓜专题合集
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group block bg-background-800 rounded-2xl overflow-hidden hover:scale-[1.02] transition-transform duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className={`p-4 ${item.accent ? 'bg-accent-500/10' : ''}`}>
                <h3 className="text-white font-semibold text-sm mb-1">
                  {item.title}
                </h3>
                <p className="text-white/40 text-xs">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}